import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronLeft"><Path d="M15 20L7 12L15 4" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronLeft;
